const comparisonFooter = {
    props: {
        label:{
            type: String,
            default: 'Compare'
        },
        name:{
            type: String,
            default: 'hdncompare'
        },
        button:{
            type: String,
            default: 'Compare'
        },
        items: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    template:
    `<div class="b-comparison-footer">
        <input type="hidden" :name="name" :value="ids">
        <div class="b-comparison-footer__label">{{label}}</div>
        <div v-for="item in restItems" class="b-comparison-footer__slot">
            <div v-if="item">
                <div class="e-comparison-chip" :style="{ backgroundImage: 'url(' + cardBg(item) + ')' }">
                    <div class="e-comparison-chip__head" v-if="item.title" v-html="item.title"></div>
                    <button @click="removeItem(item)" class="e-comparison-chip__remove" type="button"></button>
                </div>
            </div>
            <div v-else class="b-comparison-footer__empty"></div>
        </div>
        <button @click="removeAll" class="b-comparison-footer__remove" type="button"></button>
        <button class="b-comparison-footer__btn" type="submit">{{button}}</button>
    </div>`,
    methods:{
        cardBg(item){
            if (item !== null && item.bg && item.bg !== "") {
                return item.bg;
            }
            return "";
        },
        removeItem(item){
            this.$emit('removeItem', item)
        },
        removeAll(){
            this.$emit('removeAll')
        }
    },
    computed:{
        restItems(){
            let arr = [].concat(...this.items)
            if(arr.length<3){
                for(var i=arr.length; i<3; i++){
                    arr.push(null)
                }
            }
            return arr
        },
        ids(){
            return this.items.map((item)=> {
                return item.id
            })
        }
    }
};
